/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomgueststitle3Inputs */

const en_statsroomgueststitle3 = /** @type {(inputs: Statsroomgueststitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room guests`)
};

const de_statsroomgueststitle3 = /** @type {(inputs: Statsroomgueststitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room Gäste`)
};

/**
* | output |
* | --- |
* | "Live Room guests" |
*
* @param {Statsroomgueststitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomgueststitle3 = /** @type {((inputs?: Statsroomgueststitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomgueststitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomgueststitle3(inputs)
	return de_statsroomgueststitle3(inputs)
});
export { statsroomgueststitle3 as "statsRoomGuestsTitle" }